/**
 * WebCardOverlay
 * 
 * A positioned card container for web that displays floating cards
 * (like ChargeAgainCard) within the app boundaries.
 * 
 * Features:
 * - Fixed positioning at a specified top offset
 * - Centered within app container boundaries
 * - Proper pointer events handling
 */

import React from 'react';
import { useWebAppContainer } from './WebAppContainer';
import { WEB_APP_MAX_WIDTH, Z_INDEX } from './constants';

interface WebCardOverlayProps {
  children: React.ReactNode;
  top: number;
  visible?: boolean;
  zIndex?: number;
}

const WebCardOverlay: React.FC<WebCardOverlayProps> = ({
  children,
  top,
  visible = true,
  zIndex = Z_INDEX.OVERLAY_CONTENT,
}) => {
  const { containerLeft, containerWidth } = useWebAppContainer();

  // Calculate the actual container position
  const actualLeft = containerLeft || Math.max(0, (window.innerWidth - WEB_APP_MAX_WIDTH) / 2);
  const actualWidth = containerWidth || Math.min(window.innerWidth, WEB_APP_MAX_WIDTH);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top,
        left: actualLeft,
        width: actualWidth,
        zIndex,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: 10,
        pointerEvents: 'none',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ pointerEvents: 'auto' }}>
        {children}
      </div>
    </div>
  );
};

export default WebCardOverlay;

